// payment-method-view.component.ts
import {
  Payout_Gateway_Enum,
  Payment_Gateway_Enum,
} from 'src/app/models/portal';
import { Component, OnInit, Input } from '@angular/core';

export enum PaymentMethodViewTypeEnum {
  icon = 'icon',
  text = 'text',
  both = 'both',
}

@Component({
  selector: 'app-payment-method-view',
  templateUrl: './payment-method-view.component.html',
  styleUrls: ['./payment-method-view.component.css'],
})
export class PaymentMethodViewComponent implements OnInit {
  payoutGateway = Payout_Gateway_Enum;
  paymentGateway = Payment_Gateway_Enum;
  paymentMethodViewTypeEnum = PaymentMethodViewTypeEnum;

  @Input() methodEnum: Payout_Gateway_Enum | Payment_Gateway_Enum | string;
  @Input() type: PaymentMethodViewTypeEnum | string = PaymentMethodViewTypeEnum.text;
  
  // NEW: Controls layout direction
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal'; 

  @Input() iconSize: number = 50;
  @Input() fluidSize: boolean = false;
  @Input() disableBG = false;

  paymentMethods = [
    {
      name: 'PayPal',
      icon: 'assets/images/svg/payment/paypal.svg?rand=1.2',
      enums: [this.payoutGateway?.paypal, this.paymentGateway?.paypal, 'paypal'],
    },
    {
      name: 'Stripe',
      icon: 'assets/images/svg/payment/stripe.svg?rand=1.2',
      enums: [this.payoutGateway?.stripe, this.paymentGateway?.stripe, 'stripe'],
    },
    {
      name: 'BTCPay',
      icon: 'assets/images/svg/payment/btcpay.svg?rand=1.2',
      enums: [this.payoutGateway?.btcpay, this.paymentGateway?.btcpay, 'btcpay'],
    },
  ];

  constructor() {}

  ngOnInit(): void {}
}